import { render } from "./ProspectServiceView.vue?vue&type=template&id=224567f5&scoped=true"
import script from "./ProspectServiceView.vue?vue&type=script&lang=js"
export * from "./ProspectServiceView.vue?vue&type=script&lang=js"

import "./ProspectServiceView.vue?vue&type=style&index=0&id=224567f5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224567f5"]])

export default __exports__